var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "mainStroke",
    id: "rep\\xE8re",
    width: 150,
    height: 150,
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n      fill-rule: evenodd;\r\n      stroke-width: 0px;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m7.53,7.06c-.13.04-.24.11-.33.21-.15.17-.15.75-.15,17.74v17.57l.19.19.19.19h35.16l.19-.19.19-.19V7.43l-.19-.19-.19-.19h-17.43c-9.59-.02-17.52,0-17.61.01m24.47,3.57c0,2.1,0,2.22.17,2.38.12.12.28.17.54.17.62,0,.63-.02.63-2.56v-2.19h8.25v15.92h-9.24l-.17.22c-.22.26-.22.64,0,.89l.17.22h9.24v15.92h-8.25v-6.07c0-5.68,0-6.08-.15-6.2-.32-.28-.93-.22-1.11.1-.05.09-.08,2.4-.08,6.16v6.01h-8.25v-.46c0-.58-.18-.79-.67-.79s-.67.21-.67.79v.46h-14v-23.58h5.07c4.99,0,5.07,0,5.25-.17.24-.23.25-.76.02-1-.16-.16-.28-.17-5.25-.17h-5.08v-8.25h23.58v2.21m-9.42,6.21c-.16.17-.17.28-.17,9.45v9.28l.23.18c.28.22.74.18.96-.09.14-.17.15-.72.15-8.92v-8.74h8.25v1.03c0,.92.02,1.05.17,1.21.22.24.76.25,1,.02.15-.16.17-.28.17-1.71s-.01-1.55-.17-1.71c-.16-.16-.28-.17-5.29-.17s-5.13,0-5.29.17"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlan);
export default __webpack_public_path__ + "static/media/plan.9d9ab875ef07273c0f29143f20777685.svg";
export { ForwardRef as ReactComponent };